import { useForm } from "react-hook-form";
import InputsFields from "../../helpers/InputFields"
import Loader from "../main/Loader";
import { toast } from "react-toastify";
import { setIsOpenDialog } from "../../store/feautures/DialogSlice";
import { useDispatch } from "react-redux";
import { DocumentInputs, fileInputDocument } from "../../utils/listInputs/DocumentInputs";
import { useAddDocumentMutation, useGetDocumentQuery, useGetFileQuery, useUpdateDocumentMutation } from "../../store/services/DocumentService";
import { DocumentAdapter, DocumentAdapterToServer, DocumentToServer } from "../../helpers/adapter/DocumentAdapter";
import { useEffect, useMemo, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import UploadedFileMoc from "../inputs/UploadedFileMoc";

type IProps = {
    type: 'add' | 'update',
    idAzienda: number,
    dataInfo?: any,
    listCategories: any
}

export default function DocumentForm({ type, idAzienda, dataInfo, listCategories }: IProps) {

    const form = useForm<DocumentToServer>();
    const [addDocument, resultAdd] = useAddDocumentMutation();
    const [updateDocument, resultUpdate] = useUpdateDocumentMutation();
    const dispatch = useDispatch();
    const { handleSubmit, reset } = form;
    const [isUpdate, setIsUpdate] = useState(false);

    let categorieList: any = useMemo(() => {
        return listCategories?.map((cat: any) => ({value: cat.id, label: cat.nome}))
    }, [listCategories]);

    const {data: dataDocumento, isLoading: isLoadingDoc}: any = useGetDocumentQuery(
        type === 'update' 
        ? {idAzienda: idAzienda, idDocument: dataInfo.id}
        : skipToken
    );

    useEffect(() => {
        if(!isLoadingDoc && dataDocumento) {
            const values = DocumentAdapter(dataDocumento.result, categorieList);
            reset(values);
        }
    }, [isLoadingDoc, dataDocumento, categorieList, listCategories])

    const handleSubmitCatData = async (dataForm: DocumentToServer) => {

        let result: any;
        const resultLabel = type === 'update' ? 'modificato' : 'creato';

        const formData = new FormData();
        if(dataForm?.document && dataForm?.document.length > 0) {
            formData.append('file', dataForm?.document[0]);
        }
        formData.append('jsonData', JSON.stringify(
            DocumentAdapterToServer(dataForm)
        ));

        if (type === 'update') {
            result = await updateDocument({ idAzienda: idAzienda, idDocument: dataInfo.id, formData});
        } else {
            result = await addDocument({idAzienda: idAzienda, formData});
        }

        if ('error' in result) {
            toast.error(`Documento non ${resultLabel}! Errore: ${result?.error?.data?.detail}`)
        } else {
            toast.success(`Documento ${resultLabel}! `);
            dispatch(setIsOpenDialog(true));
        }
    }

    return (
        <div className="p-10 flex flex-col gap-y-8">
            {(resultAdd.isLoading || resultUpdate.isLoading || isLoadingDoc) && <Loader />}
            <h5 className="text-[#064e3b] text-xl font-medium">
                {type === 'add' && 'Aggiungi '}
                {type === 'update' && 'Modifica '}
                documento
            </h5>

            <form onSubmit={handleSubmit(handleSubmitCatData)} className="flex flex-col md:grid md:grid-cols-2 gap-y-8 gap-x-5 items-start" >
                {type === 'update' && <UploadedFileMoc documento={dataDocumento?.result} action={setIsUpdate} />}
                {(type === 'add' || isUpdate) && !isLoadingDoc &&
                    <div className="col-span-2">
                        <InputsFields arrFields={fileInputDocument(type)} form={form} />
                        <p className="text-gray-400 text-base">ATTENZIONE: sono consentiti solo file PDF.</p>
                    </div>
                }
                <InputsFields arrFields={DocumentInputs(categorieList)} form={form} />
                <div className="flex justify-end my-6 col-span-2">
                    <button className="h-10 bg-[#064e3b] text-white px-5 w-64 rounded-lg text-md">Salva</button>
                </div>
            </form>
        </div>
    )
}